import React, { useState, useEffect } from 'react'
import axios from 'axios'
// eslint-disable-next-line
import { Button, Space, Breadcrumb, Switch, Modal, Tag } from 'antd'
// eslint-disable-next-line
import {
  getHeaders,
  successNotification,
  errorNotification,
  usersUrl
} from '../../config'
// eslint-disable-next-line
import { CheckSquareOutlined, WarningOutlined } from '@ant-design/icons'
import Update from './Update'
import PageLoader from 'components/Layouts/PageLoader'
import WithUser from 'hocs/WithUser'
import PropTypes from 'prop-types'

const Detail = props => {
  const [user, setUser] = useState({
    email: '',
    firstName: '',
    lastName: '',
    otherNames: '',
    phoneNumber: '',
    jobTitle: '',
    userType: '',
    isActive: null,
    branches: []
  })

  // eslint-disable-next-line
  const [serverErrors, setServerErrors] = useState({})
  const [loading, setLoading] = useState(false)
  const [showModal, setShowModal] = useState(false)
  const [showDeleteModal, setShowDeleteModal] = useState(false)

  const getUser = () => {
    setLoading(true)
    axios
      .get(usersUrl + '/' + props.match.params.id + '/retrieve', {
        headers: getHeaders()
      })
      .then(res => {
        setLoading(false)
        setUser(res.data)
      })
      .catch(() => {
        setLoading(false)
        errorNotification('Error getting user data, retry.')
      })
  }

  useEffect(() => {
    getUser()
    // eslint-disable-next-line
  }, [])

  // eslint-disable-next-line
  const handleCheck = stateName => value => {
    setUser({ ...user, [stateName]: value })
  }

  const handleActivate = stateName => value => {
    setLoading(true)
    axios
      .post(usersUrl + '/' + user.id + '/activate', user, {
        headers: getHeaders()
      })
      .then(() => {
        setLoading(false)
        setUser({ ...user, [stateName]: value })
        successNotification('User Activated')
      })
      .catch(() => {
        setLoading(false)
        errorNotification('Error activating user, retry.')
      })
  }

  const handleDeactivate = stateName => value => {
    setLoading(true)
    axios
      .post(usersUrl + '/' + user.id + '/deactivate', user, {
        headers: getHeaders()
      })
      .then(() => {
        setLoading(false)
        setUser({ ...user, [stateName]: value })
        successNotification('User Deactivated')
      })
      .catch(() => {
        setLoading(false)
        errorNotification('Error deactivating user, retry.')
      })
  }

  const handleDeleteUser = () => {
    axios
      .post(
        usersUrl + '/' + props.match.params.id + '/delete-user',
        {},
        {
          headers: getHeaders()
        }
      )
      .then(() => {
        successNotification('User Deleted')
        props.history.push('/users')
      })
      .catch(err => {
        if (err.response) {
          setServerErrors(err.response.data)
        }
        errorNotification('Error deleting user, retry.')
      })
  }

  return (
    <PageLoader className="container" loading={loading}>
      <div className="row">
        <div className="col-md-12">
          <Breadcrumb>
            <Breadcrumb.Item href="/">
              {/* <HomeOutlined /> */}
              <span>Home</span>
            </Breadcrumb.Item>
            <Breadcrumb.Item href="/users">System Users</Breadcrumb.Item>
            <Breadcrumb.Item>Update User</Breadcrumb.Item>
          </Breadcrumb>
          <br />
          <br />
          <div className="row">
            <div className="col-md-10 offset-md-1">
              <div className="card mb-4rem">
                <div className="card-header">User Details</div>
                <div className="card-body">
                  <div
                    className="row"
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      justifyContent: 'space-between'
                    }}
                  >
                    <div className="col-md-5 mb-2rem">
                      <div>
                        <b>First Name</b>
                      </div>{' '}
                      {user.firstName}
                    </div>

                    <div className="col-md-5 mb-2rem">
                      <div>
                        <b>Last Name</b>
                      </div>
                      {user.lastName}
                    </div>

                    <div className="col-md-5 mb-2rem">
                      <div>
                        <b>Phone Number</b>
                      </div>
                      {user.phoneNumber}
                    </div>

                    <div className="col-md-5 mb-2rem">
                      <div>
                        <b>Email</b>
                      </div>
                      {user.email}
                    </div>

                    <div className="col-md-5 mb-2rem">
                      <div>
                        <b>Job Title</b>
                      </div>
                      {user.jobTitle}
                    </div>

                    <div className="col-md-5 mb-2rem">
                      <div>
                        <b>User Type</b>
                      </div>
                      {user.userType}
                    </div>

                    <div className="col-md-5 mb-2rem">
                      <div>
                        <b>Assigned Branches</b>
                      </div>
                      {user.branches.map((ow, i) => (
                        <Tag color="blue" key={i}>{`${ow.name}`}</Tag>
                      ))}
                    </div>

                    <div className="col-md-5 mb-2rem">
                      <div>
                        <b>Account Status</b>
                      </div>
                      {user.isActive ? (
                        <div className="" style={{ color: 'green' }}>
                          Active{' '}
                          {<CheckSquareOutlined style={{ color: 'green' }} />}{' '}
                        </div>
                      ) : (
                        <div className="" style={{ color: 'red' }}>
                          Inactive{' '}
                          {<WarningOutlined style={{ color: 'red' }} />}{' '}
                        </div>
                      )}
                    </div>

                    {user.id !== props.authUser.user.id ? (
                      <div className="col-md-5 mb-2rem">
                        <div>
                          <b>
                            {user.isActive ? 'Deactivate' : 'Activate'} Account
                          </b>
                        </div>
                        <Switch
                          checked={user.isActive}
                          onChange={
                            user.isActive
                              ? handleDeactivate('isActive')
                              : handleActivate('isActive')
                          }
                        />
                      </div>
                    ) : null}

                    <div className="col-md-12 flex flex-row justify-content-end">
                      <div>
                        <Space>
                          <Button onClick={() => props.history.goBack()}>
                            Go Back
                          </Button>
                          <Button
                            type="primary"
                            onClick={() => {
                              setShowModal(true)
                            }}
                            loading={loading}
                          >
                            Update Account
                          </Button>

                          {user.id !== props.authUser.user ? (
                            <Button
                              type="danger"
                              onClick={() => {
                                setShowDeleteModal(true)
                              }}
                              loading={loading}
                            >
                              Delete User
                            </Button>
                          ) : null}
                        </Space>
                      </div>
                    </div>

                    <Modal
                      title="Update Account Details"
                      centered
                      open={showModal}
                      onOk={() => setShowModal(false)}
                      onCancel={() => setShowModal(false)}
                      footer={null}
                      width={1000}
                    >
                      <Update
                        user={user}
                        handleCancel={() => {
                          setShowModal(false)
                          getUser()
                        }}
                      />
                    </Modal>

                    <Modal
                      title="Do You Really Want to Delete This User?"
                      centered
                      open={showDeleteModal}
                      onOk={() => setShowDeleteModal(false)}
                      onCancel={() => setShowDeleteModal(false)}
                      footer={null}
                    >
                      <div
                        className="p-3"
                        style={{
                          display: 'flex',
                          flexDirection: 'column',
                          justifyContent: 'center'
                        }}
                      >
                        <span className="text-danger mb-3">
                          Deleting this user may not cause issues with existing
                          cars or orders they've managed but their past
                          activity data might be difficult to track. It is
                          therefore advisable to temporarily deactivate their
                          account instead.
                        </span>
                        <Button
                          type="danger"
                          onClick={() => {
                            handleDeleteUser()
                          }}
                          loading={loading}
                        >
                          Continue to Delete User
                        </Button>
                      </div>
                    </Modal>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </PageLoader>
  )
}

Detail.propTypes = {
  authUser: PropTypes.shape({
    user: PropTypes.object
  })
}

export default WithUser(Detail)
